class NaptonCanalTransition extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.loadObserver?.disconnect();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.inView = false;
    this.reduced.addEventListener('change', () => this.syncMotion(), { signal });
    document.addEventListener('visibilitychange', () => this.syncMotion(), { signal });
    if ('IntersectionObserver' in window) {
      this.loadObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) this.loadArtwork();
      }, { rootMargin: '200px 0px' });
      this.loadObserver.observe(this);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.syncMotion();
      }, { threshold: .1 });
      this.observer.observe(this);
    } else {
      this.loadArtwork();
      this.inView = true;
    }
    this.syncMotion();
  }
  loadArtwork() {
    const template = this.querySelector('[data-transition-art]');
    if (template) {
      this.prepend(template.content.cloneNode(true));
      template.remove();
    }
    this.dataset.loaded = 'true';
    this.loadObserver?.disconnect();
    this.syncMotion();
  }
  syncMotion() {
    const loaded = this.dataset.loaded === 'true';
    this.classList.toggle('nct-playing', loaded && this.inView && !this.reduced.matches && !document.hidden);
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.loadObserver?.disconnect();
  }
}
if (!customElements.get('napton-canal-transition')) customElements.define('napton-canal-transition', NaptonCanalTransition);


